// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"437f63dd","651":"1710929a","999":"4f524366"}[chunkId] + ".chunk.js";
};